<script>
    import formasPagamento from '~js/formas-pagamento-transferencia';
    import 'vue-strap/dist/vue-strap-lang';
    import { datepicker } from 'vue-strap';

  export default {
    components: { datepicker },
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
      edicao: {
        type: Boolean,
        required: false, 
        default: false, 
      },
    },
    data() {
      return {
        formasPagamento: formasPagamento.slice(0, -1),
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      permitirCriarSolicitacao(data) {
        return !(data && moment(data).add(1, "d").diff(moment()) < 0);
      },
      validar() {
        return this.$validator.validateAll();
      },
    },
    computed: {

    },
    mounted() {

    }
  }
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-3">
        <div class="form-group required" :class="{'has-error': errors.has('dataTransferencia')}">
          <label class="control-label" for="dataTransferencia">Data transferência</label>

          <datepicker id="dataTransferencia"
                      format="dd/MM/yyyy"
                      lang="pt-BR"
                      v-model="solicitacao.dataTransferencia"
                      v-mascara="'data-mask'"
                      placeholder="  /  /     "
                      data-vv-name="dataTransferencia"
                      data-vv-as="data transferência"
                      v-validate="`required|date_format:DD/MM/YYYY`">
          </datepicker>

              <p class="text-danger" v-show="errors.has('dataTransferencia')">{{ errors.first('dataTransferencia') }}</p>
        </div>
      </div>

      <div class="col-lg-5">
        <div class="form-group">
          <label class="control-label" for="nrDocumento">Número documento</label>

          <input id="nrDocumento"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.documento"
                 maxlength="50">
        </div>
      </div>

      <div class="col-lg-4">
        <div class="form-group" :class="{'has-error': errors.has('valorTransferencia')}">
          <label class="control-label" for="valor-transferencia">Valor transferência</label>

          <input type="text"
                 class="form-control text-right"
                 id="valor-transferencia"
                 v-model="solicitacao.valorTransferencia"
                 data-vv-name="valorTransferencia"
                 data-vv-as="valor transferência"
                 disabled="disabled"
                 v-validate="'required'"
                 v-mascara="'moeda'">

          <p class="text-danger" v-show="errors.has('valorTransferencia')">{{ errors.first('valorTransferencia') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
          <label class="control-label" for="complemento">Complemento</label>

          <input id="complemento"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.complementoTransferencia"
                 maxlength="300">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group required" :class="{'has-error': errors.has('observacao')}">
          <label class="control-label" for="observacao">Observação</label>

          <textarea class="form-control"
                    id="observacao"
                    v-model="solicitacao.observacao"
                    data-vv-name="observacao"
                    data-vv-as="observação"
                    v-validate="'required'">
          </textarea>

          <p class="text-danger" v-show="errors.has('observacao')">{{ errors.first('observacao') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-transferencia/componentes/compartilhado/FormDadosCadastrais.vue